/**
 * useGuestScanTransfer — 로그인 성공 시 비회원 스캔 기록을 계정으로 이전 (기획확정안 §4.3).
 *
 * "비회원으로 스캔한 최근 5장도 로그인 후 계정의 스캔 기록으로 이전"
 *
 * RootLayout 에서 1회 마운트한다. 비인증 → 인증 **전이 시점**에만 동작하고,
 * 이미 로그인된 채로 앱을 켠 경우(=이전할 비회원 기록이 없음)에는 아무 일도 하지 않는다.
 *
 * ⚠ 평생 5회 카운터는 이전하지 않는다 — transferToAccount() 가 history 만 비우고
 * count 는 남긴다 (§4.1 "초기화하지 않음").
 */
import { useEffect, useRef } from "react";
import { useAuthStore } from "../store/authStore";
import { useGuestScanStore } from "../store/guestScanStore";

export function useGuestScanTransfer(): void {
  const isAuthenticated = useAuthStore((s) => !!s.accessToken);
  const wasAuthenticatedRef = useRef(isAuthenticated);

  useEffect(() => {
    const wasAuthenticated = wasAuthenticatedRef.current;
    wasAuthenticatedRef.current = isAuthenticated;

    // 비인증 → 인증 전이에서만 이전한다.
    if (wasAuthenticated || !isAuthenticated) return;

    const entries = useGuestScanStore.getState().transferToAccount();
    if (entries.length === 0) return;

    // TODO(api): sc_scan_session_* 에 기록 이전 (POST /api/v1/user/scan-history/import).
    // 서버 API 전까지는 로컬 기록만 비우고 이전 대상을 로그로 남긴다 —
    // 조용히 버리면 나중에 "왜 기록이 없지" 를 추적할 수 없다.
    console.info("[guest-scan] 계정으로 이전할 비회원 스캔 기록", entries);
  }, [isAuthenticated]);
}
